import React, { useMemo } from "react";
import styles from "./formBlock.module.scss";

interface FormBlockProps {
  title: string | React.ReactNode;
  typeStr?: string;
  titleDesc?: string;
  content: React.ReactNode;
  etc?: React.ReactNode;
  className?: string;
}

export const FormWrap = ({ children }: { children: React.ReactNode }) => {
  return (
    <form onSubmit={(e) => e.preventDefault()} className={styles["form-wrap"]} noValidate>
      {children}
    </form>
  );
};

export const FormBlock = ({
  title,
  typeStr,
  titleDesc,
  content,
  etc,
  className,
}: FormBlockProps) => {
  const prevClassCheck = className ? className?.includes("form-block") : false;
  return (
    <div className={`${styles["form-block"]} ${className ? className : ""}`}>
      {title && (
        <div className={`${styles["form-title"]} ${prevClassCheck ? "form-title" : ""}`}>
          <div className={`${styles["title"]} ${prevClassCheck ? "title" : ""}`}>{title}</div>
          {typeStr && !titleDesc && (
            <div className={`${styles["necessary"]} ${prevClassCheck ? "necessary" : ""}`}>
              <span>*</span>
              {typeStr}
            </div>
          )}
          {titleDesc && (
            <div className={`${styles["desc"]} ${prevClassCheck ? "desc" : ""}`}>{titleDesc}</div>
          )}
        </div>
      )}
      <div className={`${styles["form-content"]} ${prevClassCheck ? "form-content" : ""}`}>
        {content}
      </div>
      {etc && etc}
    </div>
  );
};
